import { Box, Paper, Typography } from "@mui/material";
import PersonCard from "./PersonCard";
import Valentin_Grimm from '../../assets/Contributors/Valentin_Grimm.jpg'
import Jessica_Rubart from '../../assets/Contributors/Jessica_Rubart.jpg'
import Laura_Geiger from '../../assets/Contributors/Laura_Geiger.jpg'
import Gudrun_Faller from '../../assets/Contributors/Gudrun_Faller.jpg'
import TH_OWL from '../../assets/Contributors/TH_OWL.png'
import HSG from '../../assets/Contributors/HS-Gesundheit.jpg'
import MJZ from '../../assets/Contributors/MJZ.jpg'
import UK_NRW from '../../assets/Contributors/UK_NRW.jpg'
import BFBF from '../../assets/Contributors/BFBF.jpg'
import FAF from '../../assets/Contributors/FAF.jpg'
import PartnerCard from "./PartnerCard";
import MoveUpButton from "./MoveUpButton";

export default function Impressum() {

    return(
        <Paper sx={{m: {xs: 1, sm: 4}, p: 4}}>
            <MoveUpButton/>
            <Typography variant="h1" color="th_color.main">Impressum</Typography>
            <Typography variant="h2" color="th_color.main">
                Impressum gemäß § 5 TMG / § 55 RStV
            </Typography>
            <br/>
            <Typography>
                Technische Hochschule Ostwestfalen-Lippe
            </Typography>
            <Typography>
                Campusallee 12
            </Typography>
            <Typography>
                32657 Lemgo
            </Typography>
            <Typography>
                Telefon: <a href="tel:+49 5261 702 0">+49 5261 702 0</a>
            </Typography>
            <Typography>
                Telefax: <a href="tel:+49 5261 702 1711">+49 5261 702 1711</a>
            </Typography>
            <Typography>
                E-Mail: <a href="mailto:pressestelle(at)th-owl.de">pressestelle(at)th-owl.de</a>
            </Typography>
            <br/>
            <Typography>

                Die Technische Hochschule Ostwestfalen-Lippe ist eine vom Land getragene rechtsfähige Körperschaft des öffentlichen Rechts.
                Sie wird vertreten durch: Professor Dr. Jürgen Krahl, Präsident der Technischen Hochschule OWL

            </Typography>
            <br/>
            <Typography variant="h3">
                Umsatzsteuer-ID
            </Typography>
            <br/>
            <Typography>
                Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: DE 125 650 309, Finanzamt Lemgo
            </Typography>
            <br/>
            <Typography variant="h3">
                Zuständige Aufsichtsbehörde
            </Typography>
            <br/>
            <Typography>

                Ministerium für Kultur und Wissenschaft des Landes Nordrhein-Westfalen,
            </Typography>
            <Typography>
                Völklinger Straße 49, 40221 Düsseldorf
            </Typography>
            <br/>
            <Typography variant="h3">
                Inhaltliche Verantwortung
            </Typography>
            <br/>
            <Typography>
                Dezernat Kommunikation und Marketing
            </Typography>
            <Typography>
                Campusallee 12
            </Typography>
            <Typography>
                32657 Lemgo
            </Typography>
            <Typography>
                Telefon: <a href="tel:+49 5261 702 2510">+49 5261 702 2510</a>
            </Typography>
            <Typography>
                    Telefax: <a href="tel:+49 5261 702 2514">+49 5261 702 2514</a>
            </Typography>
            <Typography>
                    E-Mail: <a href="mailto:pressestelle(at)th-owl.de">pressestelle(at)th-owl.de</a>
            </Typography>  
            <br/> 
            <Typography>

                Für alle anderen Internetseiten (bspw. der Fachbereiche, Institute, Betriebseinheiten oder Verwaltungsstellen) liegt die inhaltliche Verantwortung bei den Stellen (oder Personen) die die Seiten erstellt oder veröffentlicht haben. Falls Sie Fragen zu einem dieser Internetangebote haben, wenden Sie sich bitte an die jeweils angegebene Stelle oder Person.
            </Typography>
            <br/>
            <Typography variant="h3">
                Haftung für Inhalte
            </Typography>
            <br/>
            <Typography>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </Typography>
            <br/>
            <Typography variant="h3">
                Haftung für Links
            </Typography>
            <br/>
            <Typography>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </Typography>
            <br/>
            <Typography variant="h3">
                Urheberrecht
            </Typography>
            <br/>
            <Typography>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </Typography>
            <br/>
            <Typography variant="h3">
                Bildrechte

            </Typography>
            <br/>
            <Typography>
                <a href="https://www.flaticon.com/de/kostenlose-icons/ubersetzen" title="Übersetzen Icons">Übersetzen Icons erstellt von Freepik - Flaticon</a>
            </Typography>
            <br/>
            <Typography>
                Die Bildrechte liegen, soweit nicht anders angemerkt, bei der Technischen Hochschule OWL.
            </Typography>
            <br/>
            <Typography variant="h3">
                Datenschutz
            </Typography>
            <br/>
            <Typography>
                Hinweise zum <a href="/privacy">Datenschutz</a>
            </Typography>
            <br/>
            <Typography variant="h3">Inhaltliche Verantwortung</Typography>
            <Box sx={{display: "flex", flexWrap: "wrap"}}>
                <PersonCard 
                    img={Valentin_Grimm}
                    university="Technische Hochschule OWL"
                    title="M.Sc."
                    name="Valentin Grimm"
                    link="https://www.th-owl.de/umwelt/fachbereich/team/valentin-grimm/"
                    phone="+49 5271 687 5032"
                    mail="valentin.grimm@th-owl.de"
                />
                <PersonCard 
                    img={Jessica_Rubart}
                    university="Technische Hochschule OWL"
                    title="Prof.'in"
                    name="Jessica Rubart"
                    link="https://www.th-owl.de/umwelt/fachbereich/team/jessica-rubart/"
                    phone="+49 5271 687 7870"
                    mail="jessica.rubart@th-owl.de"
                />
                <PersonCard 
                    img={Laura_Geiger}
                    university="Hochschule für Gesundheit Bochum"
                    title="M.A."
                    name="Laura Geiger"
                    // link="https://www.th-owl.de/umwelt/fachbereich/team/valentin-grimm/"
                    // phone="+49 5271 687 5032"
                    mail="laura.geiger@hs-gesundheit.de"
                />
                <PersonCard 
                    img={Gudrun_Faller}
                    university="Hochschule für Gesundheit Bochum"
                    title="Prof.'in"
                    name="Gudrun Faller"
                    link="https://gudrun-faller.de/"
                    // phone="+49 5271 687 5032"
                    mail="gudrun.faller@hs-gesundheit.de"
                />
            </Box>
            {/* <Typography variant="h3">Technische Umsetzung</Typography>
            <Box sx={{display: "flex", flexWrap: "wrap"}}>
                <PersonCard 
                    img={Valentin_Grimm}
                    university="Technische Hochschule OWL"
                    title="M.Sc."
                    name="Valentin Grimm"
                    link="https://www.th-owl.de/umwelt/fachbereich/team/valentin-grimm/"
                    phone="+49 5271 687 5032"
                    mail="valentin.grimm@th-owl.de"
                />
            </Box> */}
            <Typography variant="h3">Partner</Typography>
            <Box sx={{display: "flex", flexWrap: "wrap"}}>
                <PartnerCard src={TH_OWL} link="https://www.th-owl.de/"/>
                <PartnerCard src={HSG} link="https://www.hs-gesundheit.de/"/>
                <PartnerCard src={MJZ} link="https://www.minijob-zentrale.de/"/>
                <PartnerCard src={UK_NRW} link="https://www.unfallkasse-nrw.de/"/>
            </Box>
            <Box sx={{display: "flex", flexWrap: "wrap", mt: 8}}>
                
                <PartnerCard src={BFBF} link="https://www.bmbf.de/"/>
                <PartnerCard src={FAF} link="https://www.forschung-fachhochschulen.de"/>
            </Box>
        </Paper>
    )
}